import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.use(Vuex)

import moment from 'moment/src/moment'


let baseConfig = {
	// system data
	language: {},
	destinations: [],
	hotels: [],
	rates: [],
	dateFormat: 'MM/DD/YYYY',
	dateFormatShort: 'ddd D MMM',
	dateFormatUltraShort: 'D MMM',

	// user selection
	destination: null,
	arrival: null,
	departure: null,
	guests: 1,
	rooms: 1,
	rate: null,
	promo: null,

	// flow data

	filteredDestinations: [],
	filteredHotels: [],
	filteredRates: [],

	mobileBreakpoint: 768, // beyond this px we fire the form on selecting a destonation directly
	errorShowTime: 1882,
	endpoint: 'https://citizenm.workmatrix.test/booking.json',
	currentlyLoading: false,
	editMode: false,
	availability: {},

	guestsMax: 2,
	roomsMax: 10,
	defaultRate: 'BEST',

	// preset date
	where: 0,
	rate_code: null,
	promo_code: null,

	// widget specific
	property_name: null,
	propertyCurrency: 'EUR',

	// show continue booking button with this link
	continueButton: null,
	continueButtonText: "continue booking",
	confirmButtonIsSubmit: false,
	continueButtonAvailable: true,

	// edit button in app booking flow
	appEditLink: null,

	// Switch to prevent editmode
	unEditable: false,

	// coming soon
	comingSoon: false,
	comingSoonText: '',
	comingSoonButtonText: 'coming soon',

	// show breakdown with this data
	breakdown: [],
	// show total?
	total: [],
	// are taxes included? no values => change currency
	taxes: null,

	// subscription
	subscription: null,
	activationValue: 0,
	activationDates: [],

	isDirty: false,
}


// Extend base config from html JSON element
const IsJsonString = function (str) {
	try {
		return (JSON.parse(str) && !!str);
	} catch (e) {
		return false;
	}
}

// support more/multiple config elements
const configElements = document.querySelectorAll( 'script.vue_config_override' )
for(let i = 0; i < configElements.length; i++){
	const configElement = configElements[i];
	if(configElement && IsJsonString(configElement.innerHTML)){
		Object.assign(baseConfig, JSON.parse( configElement.innerHTML ))
	}
}
// one cinfgi overrite is intended
const configElement = document.querySelectorAll( '#vue_config_override' )
if(configElement && IsJsonString(configElement.innerHTML)){
	Object.assign(baseConfig, JSON.parse( configElement.innerHTML ))
}

// set a solid base
baseConfig.baseDestinations = baseConfig.destinations
baseConfig.baseHotels = baseConfig.hotels
baseConfig.baseRates = baseConfig.rates

// reformat previously set dates
if(baseConfig.arrival) {
	baseConfig.arrival = baseConfig.arrival.replace("\\/", '/')
}
if(baseConfig.departure) {
	baseConfig.departure = baseConfig.departure.replace('\\/', '/')
}

// check local storage for preferred currency
if (localStorage && localStorage.getItem('preferredCurrency')) {
	baseConfig.propertyCurrency = localStorage.getItem('preferredCurrency');
}

window.vue_baseConfig = baseConfig;

const store = new Vuex.Store({
	state: baseConfig,
	mutations: {
		initializeActivationdateValue(state) {
			if(state.activationDates.length){
				state.activationValue = state.activationDates[0].value
			}
			else {
				state.activationValue = ''
			}
		},
		setActivationValue(state, val) {
			state.activationValue = val
		},
		updateFavorites (state, favorites) {
			state.favorites = favorites
		},

		setDestination(state, payload) {
			state.destination = payload.destination
		},

		setRooms (state, rooms) {
			state.rooms = parseInt(rooms) || 1
		},
		setGuests (state, guests) {
			state.guests = parseInt(guests) || 1
		},
		setRate (state, rate) {
			state.rate = rate
		},
		setPromo (state, promo) {
			state.promo = promo
		},
		setArrival (state, arrive) {
			state.arrival = arrive
		},
		setDeparture (state, depart) {
			state.departure = depart
		},

		setEditmode (state, edit) {
			state.editMode = edit
		},

		startLoading(state) {
			state.currentlyLoading = true
		},
		stopLoading(state) {
			state.currentlyLoading = false
		},

		setAvailability(state, availability) {
			state.availability = availability
		},

		updateAvailability(state, payload) {
			state.availability = {...state.availability, ...payload.availability}
		},

		updateDestinations(state, payload){
			if(payload.destinations) {
				state.destinations = payload.destinations
			}
			else {
				state.destinations = state.baseDestinations
			}

			if(state.rate.cbp_page > 0) {
				state.destinations = []
			}
		},
		updateHotels(state, payload){
			if(payload.hotels) {
				state.hotels = payload.hotels
			}
			else {
				state.hotels = state.baseHotels
			}
		},
		updateRates(state, payload) {
			if(payload.rates) {
				state.rates = payload.rates
			}
			else {
				state.rates = state.baseRates
			}
		},
		setCurrency(state, newCurrency) {
			try{
				localStorage.setItem('preferredCurrency', newCurrency);
			} catch (e) { /* silence */ }
			state.propertyCurrency = newCurrency
		},
		setDirty(state){
			state.isDirty = true
		},
	},
	actions: {

		enterEditmode(context) {
			context.commit('setEditmode', true)
		},

		// API triggers
		loadAvailability(){
			return
			/*
			// axios call
			if(!context.state.destination && !context.state.promo && !(context.state.rate && context.state.rate.code) ) return

			context.dispatch('toggleLoading', 1);

			const linkLoad = {
				extendedData: 1,
				destination: context.state.destination ? context.state.destination.id : null,
				startdate: context.state.arrival,
				//enddate: context.state.departure,
				//rooms: context.state.rooms,
				guests: context.state.guests,
				promo: context.state.promo,
				ratecode: context.state.rate ? context.state.rate.code : null
			}

			// custom startdate given?
			if(payload && payload.startdate) {
				linkLoad.startdate = moment(payload.startdate).format(context.state.dateFormat)
			}

			const url = context.state.endpoint + '?' + Object.entries(linkLoad)
				.map(
					([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
				)
				.join("&");

			axios.get(url)
				.then(res => {
					//context.commit('updateAvailability', res.data)
					context.commit('updateRates', res.data)
					context.commit('updateDestinations', res.data)
					context.commit('updateHotels', res.data)
				})
				.catch(function () {
					// handle error => fail silently
					context.commit('stopLoading')
				})
				.then(() => {
					context.dispatch('toggleLoading')
				})

			 */
		},

		toggleLoading(context, status) {
			if(status){
				return context.commit('startLoading')
			}
			return context.commit('stopLoading')
		},

		destinationChange(context){
			context.dispatch('loadAvailability')
		},

		dateChange(context){
			context.dispatch('loadAvailability')
		},

		packageChange(context){
			context.dispatch('loadAvailability')
		},

		// filter destinations
		filterDestinations(context, filterString) {
			let newDestinations = [];
			if(filterString == '') {
				newDestinations = context.state.destinations.map(dest => {
					dest.invisible = false
					dest.name = dest.name.replace(/(<([^>]+)>)/gi, "")
					return dest
				})
			} else {

				const re = new RegExp(filterString, 'i')

				newDestinations = context.state.destinations.map(dest => {
					dest.invisible = true
					dest.name = dest.name.replace(/(<([^>]+)>)/gi, "")

					if (!dest.inactive && dest.name.search(re) >= 0) {
						dest.invisible = false
						dest.name = dest.name.replace(re, '<span class="highlight">$&</span>')
					}
					return dest
				})
			}

			context.commit('updateDestinations', {destinations: newDestinations})
		},

		// filter hotels
		filterHotels(context, filterString){

			let newHotels = []

			if(filterString == '') {
				newHotels = context.state.hotels.map(hotel => {
					hotel.invisible = false
					hotel.name = hotel.name.replace(/(<([^>]+)>)/gi, "")

					return hotel
				})
			}
			else {

				const re = new RegExp(filterString, 'i')

				newHotels = context.state.hotels.map(hotel => {
					hotel.invisible = true
					hotel.name = hotel.name.replace(/(<([^>]+)>)/gi, "")

					if (!hotel.inactive && hotel.name.search(re) >= 0) {
						hotel.invisible = false
						hotel.name = hotel.name.replace(re, '<span class="highlight">$&</span>')
					}
					return hotel
				})
			}

			context.commit('updateHotels', { hotels: newHotels })
		},

		// select a destination from the list
		selectDestination (context, destination) {
			const selectedDestination = [... context.state.destinations].concat(context.state.hotels).filter(dest => dest.id == parseInt(destination))

			// reset availability
			context.commit('setAvailability', {})

			if(selectedDestination.length) {
				context.commit('setDestination', { destination: selectedDestination.shift() })
			}
			else {
				context.commit('setDestination', { destination: null })
			}
			context.dispatch('loadAvailability')
		},

		// initially force a selected destination
		forceDestination(context, destination) {
			context.commit('setAvailability', {})

			if(destination) {
				context.commit('setDestination', { destination: destination })
			}
			else {
				context.commit('setDestination', { destination: null })
			}
		},

		traveldates (context, payload) {

			const arrival = payload.arrival ? moment(payload.arrival).format(context.state.dateFormat) : moment().format(context.state.dateFormat)
			const departure = payload.departure ? moment(payload.departure).format(context.state.dateFormat) : moment().add(1, 'day').format(context.state.dateFormat)

			context.commit('setArrival', arrival)
			context.commit('setDeparture', departure)
		},

		chooseRate(context, payload) {
			const newRate = payload && payload.rate ? payload.rate : null
			context.commit('setRate', newRate)
			context.dispatch('packageChange')
		},
		initRate(context, rateCode) {
			const newRate = context.state.rates.filter(rate => rate.code == rateCode)
			context.commit('setRate', newRate.shift())
			context.dispatch('packageChange')
		},
		addPromo(context, payload) {
			const newPromo = payload && payload.promo ? payload.promo : null
			context.commit('setPromo', newPromo)
			context.dispatch('packageChange')
		},
		clearRate(context) {
			context.commit('setRate', null)
		},

		validateUserSelection() {
		},

		/*
		Tracking not via VUE atm

		trackExtrasToDdm(context) {
			context.dispatch('_track', 'booking.extras');
		},

		trackUpdateToDdm(context) {
			const trackingData = {
				details: {
					action: 'modify'
				},
				booking: {
					arrival: '20210627',
					departure: '201210628',
					duration: 1,
					daysToArrival: 24,
					arrival_day: 'Sunday',
					arrival_week: '26',
					arrival_month: 'march',
					currency: 'EUR',
					value: 230.85
				},
				products: []
			}
			const hotelroom = {
				name: 'hotelroom',
				guests: context.state.guests,
				quantity: context.state.rooms
			}

			if(context.state.destination) {
				if (context.state.destination.code) {
					trackingData.booking.hotel = context.state.destination.code
					trackingData.booking.city = context.state.destination.city

					// hotelroom
					hotelroom.id = 'AMS20210627RM'
					hotelroom.brand = 'AMS'
					hotelroom.category = 'AMS/room/hotel'
				} else {
					trackingData.booking.hotel = ''
					trackingData.booking.city = context.state.destination.name
				}
			}

			trackingData.products.push(hotelroom)

			// tracking goes here
			context.dispatch('_track', {event: 'booking.basket.update', data: trackingData});
		},

		_track(context, payload) {
			console.log(payload.data);
			if(typeof window._ddm != 'undefined') {
				window._ddm.trigger(payload.event, payload.data);
			}
		}
		*/
	}
})

export default store
